import { Component, OnInit } from '@angular/core';
import {
    DateService,
    InsurancePolicyDataService, NewModalModule,
    NewModalRef as ModalRef,
    PolicyProductIdEnum,
    PurchasedProductInterface,
} from 'outshared-lib';
import { Observable } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import { WucButtonModule, WucCardModule, WucIconUiModule, WucLinkModule } from '@inshared/website-ui-components';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { DateFormatPipeModule } from '@inshared/shared/util-pipes';

@Component({
    standalone: true,
    selector: 'ins-insurance-end-product-success-modal',
    templateUrl: 'insurance-end-product-success.modal.html',
    styleUrls: ['insurance-end-product-success.modal.scss'],
    imports: [
        AsyncPipe,
        DateFormatPipeModule,
        NewModalModule,
        NgForOf,
        NgIf,
        WucButtonModule,
        WucCardModule,
        WucIconUiModule,
        WucLinkModule,
    ]
})
export class InsuranceEndProductSuccessModal implements OnInit {

    public purchasedProduct: PurchasedProductInterface;
    public endDate: string;
    public lastDay: string;
    public productIds: PolicyProductIdEnum[] = [
        PolicyProductIdEnum.Car,
        PolicyProductIdEnum.Moped,
        PolicyProductIdEnum.Caravan,
        PolicyProductIdEnum.Pet,
        PolicyProductIdEnum.Motorcycle,
        PolicyProductIdEnum.Travel,
        PolicyProductIdEnum.Home,
        PolicyProductIdEnum.Bicycle,
    ];

    public crossSellProducts$: Observable<PurchasedProductInterface[]>;

    constructor(
        private modalRef: ModalRef<InsuranceEndProductSuccessModal>,
        private readonly dateService: DateService,
        private insurancePolicyDataService: InsurancePolicyDataService,
    ) {
    }

    public ngOnInit(): void {
        this.setLastDay();
        this.setCrossSellProducts();
    }

    public dismiss(): void {
        this.modalRef.close();
    }

    private setLastDay(): void {
        this.lastDay = this.dateService
            .subtract(this.endDate, 1, 'day', 'dddd D MMMM YYYY', { locale: 'nl' });
    }

    private setCrossSellProducts(): void {
        this.crossSellProducts$ = this.insurancePolicyDataService.getPurchasedProducts$().pipe(
            takeWhile(() => this.productIds.includes(this.purchasedProduct?.productId)),
            map((purchasedProducts) => purchasedProducts
                .filter((purchasedProduct) => this.filterByProductId(purchasedProduct))
                .filter((purchasedProduct) => this.filterByStartDate(purchasedProduct)),
            ),
            takeWhile((purchasedProducts) => purchasedProducts.length > 0),
        );
    }

    private filterByProductId(purchasedProduct: PurchasedProductInterface): boolean {
        return [
            PolicyProductIdEnum.Liability,
            PolicyProductIdEnum.Accidents,
            PolicyProductIdEnum.LegalAssistance,
        ].includes(purchasedProduct?.productId);
    }

    private filterByStartDate(purchasedProduct: PurchasedProductInterface): boolean {
        return purchasedProduct?.product?.startDate === this.purchasedProduct?.product?.startDate;
    }
}
